import { api } from '@/api/client'

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) return null
  try {
    return await navigator.serviceWorker.register('/sw.js')
  } catch {
    return null
  }
}

export async function checkNotificationStatus(): Promise<{ enabled: boolean }> {
  try {
    return await api.get<{ enabled: boolean }>('/api/reminders')
  } catch {
    return { enabled: false }
  }
}

export async function toggleNotification(enable: boolean): Promise<boolean> {
  try {
    if (enable && 'Notification' in window) {
      const perm = await Notification.requestPermission()
      if (perm !== 'granted') return false
    }
    const res = await api.post<{ ok: boolean }>('/api/reminders', { enabled: enable })
    return res.ok
  } catch {
    return false
  }
}

let _reminderInterval: ReturnType<typeof setInterval> | null = null

export function scheduleReminderCheck() {
  if (_reminderInterval) clearInterval(_reminderInterval)
  const check = async () => {
    try {
      const res = await api.get<{ reminders?: Array<{ title: string; date: string }> }>('/api/reminders/check')
      if (res.reminders?.length && 'Notification' in window && Notification.permission === 'granted') {
        res.reminders.forEach(r => {
          new Notification('日迹提醒', { body: `${r.title} - ${r.date}` })
        })
      }
    } catch { /* ignore */ }
  }
  check()
  _reminderInterval = setInterval(check, 24 * 60 * 60 * 1000)
}

export function stopReminderCheck() {
  if (_reminderInterval) {
    clearInterval(_reminderInterval)
    _reminderInterval = null
  }
}
